import React from 'react';
import ResetSuccessView from '../Views/TO/Reset/ResetSuccessView.js';

class ResetSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props
        }
        this.login = this.login.bind(this);
    }

    login() {
        const dest = this.props.loginURI === "" ? "/" : this.props.loginURI
        window.location.href = dest;
    }

    render() {
        return (
            <ResetSuccessView
                login={this.login}
                style={this.props.style}
            />
        );
    }
}

export default ResetSuccess;